import Web3 from 'web3'
// eslint-disable-next-line no-unused-vars
import {address, ABI} from './wristersContract'
// eslint-disable-next-line no-unused-vars
let getContract = new Promise(function (resolve, reject) {
 let web3 = new Web3(window.ethereum)
 let wristersContract = new web3.eth.Contract(ABI, address)
 resolve(wristersContract)
})
export default getContract